var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.BModal, {
    attrs: {
      size: "lg",
      title: "Resume Subscription",
      "modal-class": "vue-need-bootstrap",
      lazy: "",
      centered: "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ cancel }) {
          return [
            !_setup.isShopifySubscription
              ? _c("span", [
                  _vm._v(
                    "\n            Resume your subscription to continue using our services.\n            "
                  ),
                  _setup.lastPrice
                    ? _c("span", [
                        _vm._v("You will continue with your previous plan of "),
                        _c("b", [
                          _vm._v(
                            "$" + _vm._s(_setup.lastPrice.Amount.toFixed(2))
                          ),
                        ]),
                        _vm._v("."),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _setup.isShopifySubscription
              ? _c("span", [
                  _vm._v(
                    "\n            Your subscription will be resumed using our\n            "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.customily.com/new-pricing",
                        target: "_blank",
                      },
                    },
                    [_vm._v("new pricing")]
                  ),
                  _vm._v(" for Shopify\n            stores."),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.ValidationObserver, {
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ handleSubmit, valid }) {
                      return [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return handleSubmit(
                                  _setup.resumeSubscriptionSubmit
                                )
                              },
                            },
                          },
                          [
                            _c(_setup.ValidationProvider, {
                              attrs: {
                                rules: "required|min:8",
                                name: "Password",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ valid, errors }) {
                                      return [
                                        _c(
                                          "b-form-group",
                                          {
                                            staticClass: "my-3",
                                            attrs: {
                                              id: "current-password-input",
                                              "label-cols": "3",
                                              "content-cols": "9",
                                              label: "Current password",
                                              "label-for":
                                                "current-password-input",
                                              "invalid-feedback": _setup.invalidPassword
                                                ? "Wrong password"
                                                : errors[0],
                                              state: _setup.invalidPassword
                                                ? false
                                                : errors[0]
                                                ? false
                                                : valid
                                                ? true
                                                : null,
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "current-password-input",
                                                type: "password",
                                                state: _setup.invalidPassword
                                                  ? false
                                                  : errors[0]
                                                  ? false
                                                  : valid
                                                  ? true
                                                  : null,
                                                disabled:
                                                  _setup.resumingSubscription,
                                              },
                                              model: {
                                                value: _setup.password,
                                                callback: function ($$v) {
                                                  _setup.password = $$v
                                                },
                                                expression: "password",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _setup.resumeSubscriptionError,
                                    expression: "resumeSubscriptionError",
                                  },
                                ],
                                staticClass:
                                  "error-message w-100 pb-3 text-center",
                              },
                              [
                                _vm._v(
                                  "\n                    Error resuming subscription\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "modal-footer row pb-0" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { type: "reset" },
                                    on: { click: cancel },
                                  },
                                  [_vm._v(" Cancel ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  _setup.LoaderBtn,
                                  {
                                    attrs: {
                                      variant: "danger",
                                      type: "submit",
                                      "loading-text": "Saving",
                                      loading: _setup.resumingSubscription,
                                      disabled:
                                        !valid || _setup.resumingSubscription,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Resume Subscription\n                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
    model: {
      value: _setup.isVisible,
      callback: function ($$v) {
        _setup.isVisible = $$v
      },
      expression: "isVisible",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }